export default "__VITE_ASSET__k36d3h13__"